export default "__VITE_ASSET__BaQiz1xH__"